import React from 'react';
import FormSection from 'components/forms/components/form-section';
import PrescreenFormSection from 'components/forms/vendor-request/prescreen-form-section';

const VendorPrescreenForm = props => (
  <FormSection
    title="Pre-Screen Information"
    stepIcon="4"
    description={description}
    inputs={<PrescreenFormSection {...props} />}
  />
);

const description = [
  <p key="desc1">
    To efficiently evaluate a Third Party, Information Security Risk and
    Compliance needs to know the following. *A minimum of one selection must be
    made for each section:
  </p>,
  <ul key="desc2">
    <li key="desc3">Type of Data*</li>
    <li key="desc4">Type of Access*</li>
    <li key="desc5">Type of Product or Service*</li>
    <li key="desc6">Importance to the Operation</li>
  </ul>,
  <p key="desc7">
    The information presented here will be submitted to the Third Party prior to
    the assessment beginning. If the Third Party disputes the information
    presented, a notification will be sent to you (the sponsor) that further
    actions are required.
  </p>,
];

export default VendorPrescreenForm;
